/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeatureEligibility } from './FeatureEligibility';
import {
    FeatureEligibilityFromJSON,
    FeatureEligibilityFromJSONTyped,
    FeatureEligibilityToJSON,
    FeatureEligibilityToJSONTyped,
} from './FeatureEligibility';

/**
 * shows the eligibility status
 * @export
 * @interface EligibilityCheckResponse
 */
export interface EligibilityCheckResponse {
    /**
     * The list of features
     * @type {Array<FeatureEligibility>}
     * @memberof EligibilityCheckResponse
     */
    features?: Array<FeatureEligibility>;
}

/**
 * Check if a given object implements the EligibilityCheckResponse interface.
 */
export function instanceOfEligibilityCheckResponse(value: object): value is EligibilityCheckResponse {
    return true;
}

export function EligibilityCheckResponseFromJSON(json: any): EligibilityCheckResponse {
    return EligibilityCheckResponseFromJSONTyped(json, false);
}

export function EligibilityCheckResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityCheckResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'features': json['features'] == null ? undefined : ((json['features'] as Array<any>).map(FeatureEligibilityFromJSON)),
    };
}

export function EligibilityCheckResponseToJSON(json: any): EligibilityCheckResponse {
    return EligibilityCheckResponseToJSONTyped(json, false);
}

export function EligibilityCheckResponseToJSONTyped(value?: EligibilityCheckResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'features': value['features'] == null ? undefined : ((value['features'] as Array<any>).map(FeatureEligibilityToJSON)),
    };
}

